import { useState } from "react";
import { Cards } from "../../../components/cards/frame/cards-frame";
import DetailHostConfiguration from "./detailHostConfiguration";
import EditHostConfiguration from "./editHostConfiguration";
import { Button } from "../../../components/buttons/buttons";
import { useLocation } from "react-router-dom";

const HostConfiguration = () => {
    const location = useLocation();
    const [isDetails, setIsDetails] = useState(location?.state?.activeTab == 9 ? false : true);

    const handleProfileUpdate = () => {
        setIsDetails(false);
    };
    return (
        <>
            {isDetails ? (
                <Cards xs={24} headless className="borderRadius common_fiter_table">
                    <DetailHostConfiguration  isDetails={isDetails}/>
                </Cards>
            ) : (
                <EditHostConfiguration isDetails={isDetails} setIsDetails={setIsDetails} />
            )}

            <div className="manage-listing-btn">
                {isDetails && (
                    <Button
                        htmlType="submit"
                        outlined
                        shape="circle"
                        type="primary"
                        key="3"
                        className="w-100 edit-btn"
                        onClick={handleProfileUpdate}
                    >
                        Edit
                    </Button>
                )}
            </div>
        </>
    )
}

export default HostConfiguration;   